import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';

import {
  InputClabe,
  InputCreditCard,
  InputCreditCardExpireTime,
  InputCurrency,
  InputMxPhone,
  InputPercentage,
} from './inputs';

function NumberControl(props) {
  const {
    disabled,
    events = {},
    name,
    onBlur,
    onChange,
    settings: { format, decimalScale, min },
    size,
  } = props;

  const inputComponent = {
    clabe: InputClabe,
    credit_card: InputCreditCard,
    credit_card_expire_time: InputCreditCardExpireTime,
    currency: InputCurrency,
    mx_phone: InputMxPhone,
    percentage: InputPercentage,
  }[format];

  return (
    <TextField
      disabled={disabled}
      error={props.error}
      fullWidth={true}
      helperText={props.helperText}
      InputProps={{
        inputComponent,
        inputProps: {
          decimalScale: format === 'currency' ? decimalScale : undefined,
          min,
        },
      }}
      label={props.label}
      name={name}
      onBlur={onBlur}
      onChange={({ target }) => {
        let { value } = target;
        if (!inputComponent) {
          value = parseFloat(value.replace(/[^\d.-]/g, ''));

          if (Number.isFinite(min) && Number.isFinite(value)) {
            value = Math.max(min, value);
          }
        }

        onChange({
          target: {
            name,
            value,
          },
        });

        if (events.onChange) {
          events.onChange({
            name,
            value: value || '',
          });
        }
      }}
      size={size}
      type={inputComponent ? 'text' : 'number'}
      variant="outlined"
      value={props.value}
    />
  );
}

NumberControl.defaultProps = {
  disabled: false,
  error: false,
  onBlur: () => { },
  onChange: () => { },
  settings: {},
};

NumberControl.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  events: PropTypes.object,
  helperText: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  settings: PropTypes.shape({
    format: PropTypes.oneOf([
      'clabe',
      'credit_card',
      'credit_card_expire_time',
      'currency',
      'mx_phone',
      'percentage',
    ]),
    decimalScale: PropTypes.number,
    min: PropTypes.number,
  }),
  size: PropTypes.oneOf([
    'small',
    'medium',
  ]),
  value: PropTypes.any,
};

export default NumberControl;
